import { toast } from "react-toastify";

export const toastSuccess = (props) => {
  const { message, position, duration } = props;
  return toast.success(message, {
    position: position || "bottom-right",
    // autoClose: false,
    autoClose: duration || 7000,
    closeOnClick: true,
  });
};
